import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DemoCredentials = () => {
  const [isVisible, setIsVisible] = useState(false);

  const credentials = [
    {
      type: 'Patient Account',
      email: 'patient@mycomind.com',
      password: 'patient123',
      description: 'Access patient dashboard with symptom tracking'
    },
    {
      type: 'Healthcare Provider',
      email: 'provider@mycomind.com',
      password: 'provider123',
      description: 'Access provider dashboard with patient management'
    }
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard?.writeText(text)?.then(() => {
      alert('Copied to clipboard!');
    });
  };

  return (
    <div className="w-full max-w-md mx-auto mt-6">
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsVisible(!isVisible)}
        className="w-full"
        iconName={isVisible ? "EyeOff" : "Eye"}
        iconPosition="left"
      >
        {isVisible ? 'Hide' : 'Show'} Demo Credentials
      </Button>
      {isVisible && (
        <div className="mt-4 space-y-3 p-4 bg-muted/30 border border-border rounded-lg animate-fade-in">
          <div className="flex items-center space-x-2 mb-3">
            <Icon name="Info" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-foreground">Demo Login Credentials</span>
          </div>
          
          {credentials?.map((cred, index) => (
            <div key={index} className="p-3 bg-card border border-border rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-medium text-foreground">{cred?.type}</h4>
                <Icon name="User" size={14} color="var(--color-muted-foreground)" />
              </div>
              
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">Email:</span>
                  <div className="flex items-center space-x-1">
                    <code className="text-xs bg-muted px-2 py-1 rounded">{cred?.email}</code>
                    <button
                      onClick={() => copyToClipboard(cred?.email)}
                      className="text-muted-foreground hover:text-foreground"
                    >
                      <Icon name="Copy" size={12} />
                    </button>
                  </div>
                </div>
                
                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">Password:</span>
                  <div className="flex items-center space-x-1">
                    <code className="text-xs bg-muted px-2 py-1 rounded">{cred?.password}</code>
                    <button
                      onClick={() => copyToClipboard(cred?.password)}
                      className="text-muted-foreground hover:text-foreground"
                    >
                      <Icon name="Copy" size={12} />
                    </button>
                  </div>
                </div>
                
                <p className="text-xs text-muted-foreground mt-2">{cred?.description}</p>
              </div>
            </div>
          ))}
          
          <div className="text-xs text-muted-foreground text-center mt-3">
            Click the copy icons to copy credentials to clipboard
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoCredentials;